<script setup lang="ts">
import { ElIcon } from 'element-plus'

import { BoxComponent, ButtonComponent, FlexComponent } from '../../..'
import type { ActionButton, FooterButtonAction } from '../content-item-details.types'
defineProps<{
  actionButtons: ActionButton[]
}>()
const emits = defineEmits<(event: 'action', action: FooterButtonAction) => void>()
</script>
<template>
  <FlexComponent align="center" justify="center" :gap="8" class="content-item-details__footer">
    <template v-for="button in actionButtons" :key="button.action">
      <BoxComponent v-if="button.action === 'download' && actionButtons.length > 1" class="content-item-details__divider" />
      <ButtonComponent variant="text" :is-loading="button.isLoading" :class="button.cssClass" @click="emits('action', button.action)">
        <template v-if="!button.isLoading" #iconLeft>
          <span v-if="button.hotkey" class="content-item-details__kbd">{{ button.hotkey }}</span>
          <ElIcon v-else-if="button.icon" :size="18">
            <component :is="button.icon" />
          </ElIcon>
        </template>
        <span v-if="!button.isLoading">{{ button.label }}</span>
      </ButtonComponent>
    </template>
  </FlexComponent>
</template>
<style scoped lang="scss">
.content-item-details__footer {
  flex-shrink: 0;
  padding: 12px 16px;
  background: var(--inverted);
  border-top: 1px solid var(--secondary-12);
}
.content-item-details__divider {
  align-self: center;
  width: 1px;
  height: 24px;
  background: var(--secondary-12);
}
.content-item-details__kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1px solid var(--secondary-48);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  color: var(--primary);
}
.content-item-details__button--approved {
  color: var(--success);
  pointer-events: none;
  .content-item-details__kbd {
    color: var(--success);
    border-color: var(--success);
  }
}
.content-item-details__button--rejected {
  color: var(--error);
  pointer-events: none;
  .content-item-details__kbd {
    color: var(--error);
    border-color: var(--error);
  }
}
</style>
